var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-5"},[_c('h1',{staticClass:"text-2xl mb-8 page-heading"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }